import React, {PureComponent} from "react";
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import TextField from 'material-ui/TextField';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import {RESOURCE_TYPES} from 'constants/baseConst';
import {PageWrapper} from '../components/PageWrapper';
import {FileInput} from '../../blocks/inputs/FileInput';
import pdfIcon from 'images/pdfFile.svg';

@inject('resourcesStore')
@observer
class ResourceForm extends PureComponent {
  handleChange = e => {
    const {resourcesStore} = this.props;

    if (e.target.name === 'file') {
      resourcesStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      resourcesStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  render() {
    const {resourcesStore, submit} = this.props;
    const {resource, errors} = resourcesStore;
    const isNew = !resource.id;

    return (
      <PageWrapper>
        <form className="resources-form" onSubmit={submit}>
          <h1>{isNew ? 'Add Resource' : 'Edit Resource'}</h1>
          <TextField
            name='title'
            floatingLabelText='Add a Title'
            fullWidth={true}
            onChange={this.handleChange}
            value={resource.title}
            errorText={errors ? errors.title : ''}
          />
          <SelectFieldWrapper
            elements={RESOURCE_TYPES}
            placeholder="Resource type:"
            name='resourse_type'
            value={resource.resourse_type}
            onChange={this.handleChange}
            errorText={errors ? errors.resourse_type : ''}
            className="select"
            fullWidth
          />
          <FileInput
            label='Add a PDF'
            placeholder='Add a PDF'
            fullWidth={true}
            onChange={this.handleChange}
            value={resource.file}
            name='file'
            type='file'
            accept='.pdf'
            errorText={errors ? errors.file : ''}
          />
          {(!!resource.file_url && !resource.file.name) && (
            <a
              href={resource.file_url}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start',
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />PDF
            </a>
          )}
          {!!resource.file.name && (
            <a
              href={resource.file.name}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start',
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />{resource.file.name}
            </a>
          )}
          <div className="row align-items-center justify-content-around">
            <button to='/' className="btn-link" type="submit">{isNew ? 'Create' : 'Edit'}</button>
            <Link to='/practice-cases' className="btn-new-white margin-left-20 red">Cancel</Link>
          </div>
        </form>
      </PageWrapper>
    );
  }
};

export default ResourceForm;



// WEBPACK FOOTER //
// ./src/modules/resources/components/ResourceForm.js